import React, { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { toast } from "sonner";
import client, { apiErr } from "@/lib/api";

export default function AdminDisputes() {
  const [disputes, setDisputes] = useState(null);
  const [filter, setFilter] = useState("all");
  const load = () => client.get("/admin/disputes").then((r) => setDisputes(r.data)).catch(() => setDisputes([]));
  useEffect(() => { load(); }, []);

  const resolveDispute = async (did, refund) => {
    const resolution = window.prompt(refund ? "ملاحظة الحل (سيتم استرداد المبلغ للمحفظة):" : "ملاحظة حل النزاع:");
    if (resolution === null) return;
    try { await client.put(`/admin/disputes/${did}/resolve`, { resolution, refund }); toast.success("تم حل النزاع"); load(); }
    catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
  };

  const list = (disputes || []).filter((d) => filter === "all" || d.status === filter);
  const openCount = (disputes || []).filter((d) => d.status === "open").length;

  return (
    <div dir="rtl">
      <h2 className="font-head text-[16px] font-bold px-4 pt-5 pb-2 flex items-center gap-1.5"><AlertTriangle size={17} style={{ color: "var(--k-ruby)" }} /> النزاعات والاستردادات ({openCount} مفتوح)</h2>
      <div className="px-4 flex gap-2 mb-2">
        {[["all", "الكل"], ["open", "المفتوحة"], ["resolved", "المحلولة"]].map(([k, l]) => (
          <button key={k} data-testid={`disp-filter-${k}`} onClick={() => setFilter(k)} className="k-tap px-3 py-1.5 rounded-lg text-[12px] font-bold" style={{ background: filter === k ? "var(--k-ink)" : "var(--k-surface)", color: filter === k ? "#fff" : "var(--k-ink)", border: "1px solid var(--k-line)" }}>{l}</button>
        ))}
      </div>
      {disputes === null ? (
        <p className="px-4 text-[13px]" style={{ color: "var(--k-ink-soft)" }}>جارٍ التحميل…</p>
      ) : list.length === 0 ? (
        <div className="mx-4 rounded-2xl p-6 text-center text-[13px]" style={{ background: "var(--k-surface)", border: "1px dashed var(--k-line)", color: "var(--k-ink-soft)" }}>لا توجد نزاعات.</div>
      ) : (
        <div className="px-4 grid grid-cols-1 md:grid-cols-2 gap-2.5 pb-6">
          {list.map((d) => (
            <div key={d.id} data-testid={`dispute-${d.id}`} className="rounded-2xl p-3.5" style={{ background: "var(--k-surface)", border: "1px solid var(--k-line)" }}>
              <div className="flex justify-between items-center mb-1">
                <span className="font-num font-bold text-[12.5px]">{d.orderId}</span>
                <span className="text-[10px] font-bold px-2 py-0.5 rounded-full" style={{ background: d.status === "open" ? "var(--k-ruby-tint)" : "var(--k-emerald-tint)", color: d.status === "open" ? "var(--k-ruby)" : "var(--k-emerald)" }}>{d.status === "open" ? "مفتوح" : "محلول"}{d.refunded ? " · مُسترد" : ""}</span>
              </div>
              <p className="text-[10.5px] mb-1" style={{ color: "var(--k-ink-soft)" }}>فتحه: {d.openedByRole === "buyer" ? "مشترٍ" : d.openedByRole === "merchant" ? "تاجر" : "مدير"}</p>
              <p className="text-[12px] mb-1">{d.reason}</p>
              {d.resolution && <p className="text-[11px] rounded-lg p-2 mt-1" style={{ background: "var(--k-paper)", color: "var(--k-ink-soft)" }}>الحل: {d.resolution}</p>}
              {d.status === "open" && (
                <div className="flex gap-1.5 mt-2">
                  <button data-testid={`dispute-refund-${d.id}`} onClick={() => resolveDispute(d.id, true)} className="k-tap flex-1 py-2 rounded-lg text-[11.5px] font-bold" style={{ background: "var(--k-emerald-tint)", color: "var(--k-emerald)" }}>حل + استرداد للمحفظة</button>
                  <button data-testid={`dispute-close-${d.id}`} onClick={() => resolveDispute(d.id, false)} className="k-tap flex-1 py-2 rounded-lg text-[11.5px] font-bold" style={{ background: "var(--k-paper)", color: "var(--k-ink)", border: "1px solid var(--k-line)" }}>حل بدون استرداد</button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
